<div class="grid ">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoInserir">
            <div style="text-align: center;">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoInserir">
            <form #f="ngForm" name="form" novalidate (ngSubmit)="salvar()">
                <div class="formgroup">
                    <div class="p-fluid p-formgrid grid">
                        <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                            <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label htmlFor="profissional">Profissional</label>
                            <p-dropdown [options]="profissionais" optionLabel="usuario.nome" [filter]="true"
                                emptyFilterMessage="Nenhum registro" placeholder="Selecione" [required]="true"
                                name="profissional" ngModel #profissional="ngModel"
                                [(ngModel)]="profissionalSelecionado">
                            </p-dropdown>
                        </div>
                        <div class="field col-12 md:col-5">
                            <label htmlFor="item">Produto/Servico</label>
                            <label class="form-control" id="item" *ngIf="tipoItemSelecionado === 3">{{
                                itemProdutoSelecionado?.descricao }}</label>
                            <label class="form-control" id="item" *ngIf="tipoItemSelecionado === 4">{{
                                itemServicoSelecionado?.descricao }}</label>
                        </div>
                        <div class="field col-12 md:col-1">
                            <button pButton pRipple type="button" pTooltip="+" icon="pi pi-plus"
                                class="p-button-success mt-5" (click)="abrirDialogItem()"></button>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="dataTransacao">Data Transação</label>
                            <p-calendar [(ngModel)]="dataRegistro" [readonlyInput]="false" [showIcon]="true"
                                dateFormat="dd/mm/yy" [showButtonBar]="true" name="dataTransacao" ngModel
                                #dataTransacao="ngModel" [required]="true">
                            </p-calendar>
                        </div>

                        <div class="field col-12 md:col-2">
                            <label htmlFor="valorItem">Valor de Venda</label>
                            <label class="form-control" id="valorItem" *ngIf="tipoItemSelecionado === 3">{{
                                itemProdutoSelecionado?.valorVenda | currency:'BRL' }}</label>
                            <label class="form-control" id="valorItem" *ngIf="tipoItemSelecionado === 4">{{
                                itemServicoSelecionado?.valorVenda | currency:'BRL' }}</label>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="desconto">Desconto</label>
                            <p-inputNumber name="desconto" ngModel #desconto="ngModel" suffix="%" [max]="100"
                                [minFractionDigits]="1" [maxFractionDigits]="2" [(ngModel)]="percentualDesconto"
                                (onBlur)="aplicarDesconto()">
                            </p-inputNumber>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="valorACobrar">Valor a Cobrar</label>
                            <p-inputNumber name="valorACobrar" ngModel #valorACobrar="ngModel" mode="currency"
                                inputId="currency-brazil" currency="BRL" locale="pt-BR" [allowEmpty]="true"
                                [required]="true" [(ngModel)]="valorCobrarInserido"
                                (onBlur)="alterarPercentualDesconto()">
                            </p-inputNumber>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="quantidade">Quantidade</label>
                            <p-inputNumber name="quantidade" ngModel #quantidade="ngModel" [allowEmpty]="false"
                                [min]="1" [required]="true" (onBlur)="calcularTotal()" [(ngModel)]="quantidadeItem">
                            </p-inputNumber>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="valorTotal">Valor Total</label>
                            <label class="form-control">{{ valorTotalCalculado | currency:'BRL' }}</label>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="dataCobranca">Data Cobrança</label>
                            <p-calendar [(ngModel)]="competencia" [readonlyInput]="false" [showIcon]="true"
                                dateFormat="dd/mm/yy" [showButtonBar]="true" name="dataCobranca" ngModel
                                #dataCobranca="ngModel" [required]="true">
                            </p-calendar>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="parcelas">Nº Parcelas</label>
                            <p-inputNumber name="parcelas" ngModel #parcelas="ngModel" [allowEmpty]="false" [min]="1"
                                [required]="true" [(ngModel)]="qtdParcelas">
                            </p-inputNumber>
                        </div>
                    </div>
                    <div class="p-fluid p-formgrid grid justify-content-between">
                        <div class="col-12 md:col-4">
                            <button type="submit" pButton
                                [icon]="progressoRequisicao ? 'pi pi-spin pi-spinner' : 'pi pi-check'" label="Salvar"
                                class="p-button-outlined p-button-success md:w-9rem"
                                [disabled]="f.invalid || !isItemSelecionado || progressoRequisicao">
                            </button>
                        </div>

                        <div class="col-12 md:col-4 flex justify-content-end">
                            <button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
                                class="p-button-outlined md:w-9rem" routerLink="/apps/consumo"></button>
                        </div>
                    </div>
                </div>
            </form>
            <p-dialog header="Adicionar Produto/Serviço" [(visible)]="mostrarDialogItem" [modal]="true"
                [style]="{width: '50vw'}" [draggable]="false" [resizable]="false" [closable]="true">
                <div class="card">
                    <div class="flex justify-content-center" *ngIf="exibirSpinnerDialog">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <p-table #tabelaListaItens [value]="listaItens" dataKey="id" [rows]="10" [rowHover]="true"
                        styleClass="p-datatable-gridlines" [paginator]="true" responsiveLayout="scroll"
                        styleClass=" p-datatable-sm" [globalFilterFields]="['codigo', 'descricao']"
                        *ngIf="!exibirSpinnerDialog">
                        <ng-template pTemplate="caption">
                            <div class="flex justify-content-between flex-column sm:flex-row">
                                <p-dropdown [options]="tiposItem" optionLabel="label" optionValue="value"
                                    emptyFilterMessage="Nenhum registro" name="situacao" ngModel #situacao="ngModel"
                                    [(ngModel)]="tipoItemSelecionado" (onChange)="carregarItens()">
                                </p-dropdown>
                                <div>
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input pInputText type="text" #filter (input)="buscar(tabelaListaItens, $event)"
                                            placeholder="Buscar" class="w-full" />
                                    </span>
                                    <span class="ml-2">
                                        <button pButton class="p-button-outlined" icon="pi pi-filter-slash"
                                            pTooltip="Limpar Filtros" (click)="limpar(tabelaListaItens)"></button>
                                    </span>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="codigo">
                                    <div>
                                        Código
                                    </div>
                                </th>
                                <th pSortableColumn="descricao">
                                    <div>
                                        Descrição
                                    </div>
                                </th>
                                <th *ngIf="tipoItemSelecionado === 3">
                                    <div>
                                        Estoque atual
                                    </div>
                                </th>

                                <th style="text-align: center;">
                                    <div>
                                        Selecionar
                                    </div>
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-item let-i="rowIndex">
                            <tr>
                                <td>
                                    <label>{{ item.codigo }}</label>
                                </td>
                                <td>
                                    <label>{{ item.descricao }}</label>
                                </td>
                                <td *ngIf="tipoItemSelecionado === 3">
                                    <label>{{ item.estoqueAtual }} {{ item.descricaoUnidadeMedida }}</label>
                                </td>

                                <td style="text-align: center;">
                                    <button pButton pRipple pTooltip="Adicionar" type="button" icon="pi pi-check"
                                        class="p-button-success" (click)="adicionarItem(item)">
                                    </button>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                            <div class="flex align-items-center justify-content-between">
                                Há {{listaItens ? listaItens.length : 0 }} Itens
                                disponíveis.
                            </div>
                        </ng-template>
                    </p-table>

                </div>
                <p-footer>
                    <button type="button" pButton icon="pi pi-times" label="Cancelar" class="p-button-danger mt-2"
                        (click)="mostrarDialogItem = false"></button>
                </p-footer>
            </p-dialog>
        </div>
    </div>
</div>